import { render, staticRenderFns } from "./MoleculeFloatingButton.vue?vue&type=template&id=2a196bbb&"
import script from "./MoleculeFloatingButton.vue?vue&type=script&lang=js&"
export * from "./MoleculeFloatingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports